import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../actions/actions';
import ShowPet from './ShowPet';
import EditPet from './EditPet';


class PetEditor extends Component {
  constructor(props) {
    super(props);
    const { petId, action } = props.match.params;
    if (action === 'new') {
      props.selectPet();
    } else {
      props.getPet(petId);
    }
  }

  render() {
    const { petVm, addPet, updatePet } = this.props;
    const { name } = petVm;
    const { action } = this.props.match.params;
    return (
      <div className="pet">
        {
          action === 'show' && <ShowPet {...this.props} />}
        {
          action === 'edit' && <EditPet
            onSubmit={(x, history) => updatePet(x, history)}
            {...this.props}
            headText={`${name} bearbeiten`}
          />
        }
        {
          action === 'new' && <EditPet
            onSubmit={(x, history) => addPet(x, history)}
            {...this.props}
            headText="Pet hinzufügen"
          />
        }
      </div>
    );
  }
}

export default connect(
  state => ({ ...state.petReducer, ...state.currentUserReducer, ...state.alertReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(withRouter(PetEditor));



// WEBPACK FOOTER //
// ./src/pages/Pet/index.js